import { ErrorInfo } from "react";

export const logError = (error: any, errorInfo?: ErrorInfo) => {
    // @ts-expect-error - ts does not know about Sentry
    window.Sentry?.captureException(error);
    // @ts-expect-error - ts does not know newrelic
    window.newrelic?.noticeError(error, {
        componentStack: errorInfo?.componentStack,
    });
};
